const iconMap = {
  'notification template': 'fas fa-bell',
  user: 'fas fa-user',
  feedbacks: 'fas fa-comment-dots',
  'employee-rating': 'fas fa-user-tie',
  diet: 'fas fa-egg',
  'diet plan template': 'fas fa-utensils',
  'privacy policy': 'fas fa-shield-alt',
};

export const getIconClass = (navItem) => {
  return iconMap[navItem.toLowerCase()] || '';
};
